import { render, staticRenderFns } from "./OrderConfig.vue?vue&type=template&id=c7824b4e&scoped=true"
import script from "./OrderConfig.vue?vue&type=script&lang=js"
export * from "./OrderConfig.vue?vue&type=script&lang=js"
import style0 from "./OrderConfig.vue?vue&type=style&index=0&id=c7824b4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7824b4e",
  null
  
)

export default component.exports